/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Consulting_DescInputs */

const en_landing_card_consulting_desc = /** @type {(inputs: Landing_Card_Consulting_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a product, an AI feature or an automation for your business.`)
};

const id_landing_card_consulting_desc = /** @type {(inputs: Landing_Card_Consulting_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun produk, fitur AI, atau automasi untuk bisnis kamu.`)
};

/**
* | output |
* | --- |
* | "Build a product, an AI feature or an automation for your business." |
*
* @param {Landing_Card_Consulting_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_consulting_desc = /** @type {((inputs?: Landing_Card_Consulting_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Consulting_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_consulting_desc(inputs)
	return en_landing_card_consulting_desc(inputs)
});